import { css } from '@emotion/react'
import { HFlow, Text, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { useField } from 'react-final-form'
import { meta } from 'view/atendimentos/atendimento-individual/model'

import { ProblemaCondicaoModel } from '../../avaliacao/components/problemas-condicoes/model-problemasCondicoes'
import { hasProblemaCondicaoGravidezAltoRiscoAtivoOuLatente } from '../../avaliacao/components/problemas-condicoes/utils/verifications-preNatal'
import { CIAP_GRAVIDEZ_ALTO_RISCO, CID_GRAVIDEZ_ALTO_RISCO } from '../model-preNatal'
import { RiscoGravidezTag } from './RiscoGravidezTag'

interface RiscoGravidezMarkerProps {
  isAltoRisco: boolean
}

const TEXTO_CIAPS_ALTO_RISCO = `CIAP2: ${CIAP_GRAVIDEZ_ALTO_RISCO.join(', ')}`
const TEXTO_CIDS_ALTO_RISCO = `CID10: Grupo Z35 (${CID_GRAVIDEZ_ALTO_RISCO.join(' / ')})`

const INFO_ICON_TEXT_CIAPS_CIDS =
  'Para alterar o risco da gestação no sistema, uma das condições abaixo deve ser incluída na Avaliação:' +
  '\n\n' +
  TEXTO_CIAPS_ALTO_RISCO +
  '\n\n' +
  TEXTO_CIDS_ALTO_RISCO

export function RiscoGravidezMarker(props: RiscoGravidezMarkerProps) {
  const { isAltoRisco } = props

  const {
    input: { value: problemasCondicoes },
  } = useField<ProblemaCondicaoModel[]>(meta.avaliacao.problemasECondicoes.absolutePath(), {
    subscription: { value: true },
  })

  return (
    <VFlow vSpacing={0.5}>
      <HFlow hSpacing={0.5} alignItems='center'>
        <Text fontWeight='bold'>Risco da gravidez</Text>
        <InfoIcon icon='infoCircleFilled' text={INFO_ICON_TEXT_CIAPS_CIDS} tooltipStyle={styles.tooltip} />
      </HFlow>
      <RiscoGravidezTag
        isAltoRisco={isAltoRisco || hasProblemaCondicaoGravidezAltoRiscoAtivoOuLatente(problemasCondicoes)}
      />
    </VFlow>
  )
}

const styles = {
  tooltip: css`
    white-space: pre-wrap;
  `,
}
